import AbstractFortnoxImporter from "./AbstractFortnoxImporter.js";
import FortnoxExtendedIntegration from "../../../../models/integration/FortnoxExtendedIntegration.js";

/**
 * `FortnoxExtendedImporter` Import wizard for the Fortnox extended integration.
 */
export default class FortnoxExtendedImporter extends AbstractFortnoxImporter {
	useFortnoxExtended() {
		return true;
	}

	routeName() {
		return "fortnox-extended";
	}

	hasIntegration() {
		return this._context.company.hasFortnoxExtendedIntegration();
	}
}

FortnoxExtendedImporter.integrationType = FortnoxExtendedIntegration.getType();
